import { render, staticRenderFns } from "./QuizGroupNameInput.vue?vue&type=template&id=3480b3f2&scoped=true&"
import script from "./QuizGroupNameInput.vue?vue&type=script&lang=ts&"
export * from "./QuizGroupNameInput.vue?vue&type=script&lang=ts&"
import style0 from "./QuizGroupNameInput.vue?vue&type=style&index=0&id=3480b3f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3480b3f2",
  null
  
)

export default component.exports